import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    EditSlotsMutation,
    EditSlotsMutationVariables,
} from './SlotsForm.mutations.generated'

export const EDIT_SLOTS: TypedDocumentNode<
    EditSlotsMutation,
    EditSlotsMutationVariables
> = gql`
    mutation editSlots($input: editEntityInput!) {
        editEntity(input: $input) {
            success
            entity {
                guid
                ... on Event {
                    children {
                        guid
                        slots
                        alreadySignedUpInSlot
                    }
                    slotsAvailable {
                        name
                        subEventGuids
                    }
                }
            }
        }
    }
`
